let idx = 0
const GAME_PAGES = {
  DISCLAIMER: idx,
  SPLASH: ++idx,
  ONBOARDING: ++idx,
  // CAMERA_ACCESS: ++idx,
  // CARD_SCAN: ++idx,
  // SCAN_CONFIRMATION: ++idx,
  // CHARACTER_SELECTION: ++idx,
  LEVEL_SELECTION: ++idx,
  GAME_PLAY: ++idx,
  // GAME_INSTRUCTIONS: ++idx,
  REPLAY: ++idx,
};

export default GAME_PAGES;
